module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-precomposed-c9a10c34f4bb9067f83ecd51dbbd797b.png";